import RegisterTemplate from "../../../templates/users/register";

const RegisterScreen = () => {
  return <RegisterTemplate />;
};

export default RegisterScreen;
